import { TYPES } from '../../common/constants';

export const setSideBar = payload => ({
  type: TYPES.SET_SIDE_BAR,
  payload,
});

